"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CloseIcon = (0, react_1.forwardRef)(function CloseIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.2945 5.23347C5.08999 5.43804 4.9751 5.71547 4.9751 6.00474C4.9751 6.29401 5.08999 6.57144 5.2945 6.77601L10.5232 12.0047L5.2945 17.2335C5.09578 17.4392 4.98583 17.7148 4.98831 18.0008C4.9908 18.2868 5.10553 18.5605 5.30779 18.7627C5.51005 18.965 5.78367 19.0797 6.0697 19.0822C6.35573 19.0847 6.6313 18.9747 6.83705 18.776L12.0658 13.5473L17.2945 18.776C17.5002 18.9747 17.7758 19.0847 18.0618 19.0822C18.3479 19.0797 18.6215 18.965 18.8238 18.7627C19.026 18.5605 19.1407 18.2868 19.1432 18.0008C19.1457 17.7148 19.0358 17.4392 18.837 17.2335L13.6083 12.0047L18.837 6.77601C19.0358 6.57026 19.1457 6.2947 19.1432 6.00866C19.1407 5.72263 19.026 5.44902 18.8238 5.24675C18.6215 5.04449 18.3479 4.92976 18.0618 4.92728C17.7758 4.92479 17.5002 5.03475 17.2945 5.23347L12.0658 10.4622L6.83705 5.23347C6.63247 5.02895 6.35504 4.91406 6.06577 4.91406C5.7765 4.91406 5.49908 5.02895 5.2945 5.23347Z", fill: "currentColor" })));
});
